import { Link } from "react-router-dom";
import { SiteNav } from "@/components/SiteNav";
import { SiteFooter } from "@/components/SiteFooter";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

export default function LandingPage() {
  return (
    <div className="relative" data-testid="landing-page">
      <div className="grain-overlay" data-testid="grain-overlay" />
      <SiteNav mode="landing" />

      <section className="bg-white px-6 py-16">
        <div className="mx-auto flex w-full max-w-6xl flex-col items-start justify-between gap-6 border-2 border-black bg-secondary/40 px-8 py-12 md:flex-row md:items-center">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.3em]" data-testid="cta-kicker">
              Ready to start
            </p>
            <h3 className="text-3xl font-bold uppercase" data-testid="cta-title">
              Move from concept to production in one flow.
            </h3>
          </div>
          <div className="flex flex-col items-start gap-3">
            <Link to="/builder" data-testid="cta-link">
              <Button
                className="group relative h-14 rounded-none border-2 border-black bg-primary px-10 text-xs font-bold uppercase tracking-[0.35em] text-primary-foreground shadow-[6px_6px_0px_0px_rgba(0,0,0,1)] transition-transform duration-200 hover:-translate-y-0.5"
                data-testid="cta-button"
              >
                Build your custom box
                <ArrowRight className="ml-3 h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" />
              </Button>
            </Link>
            <span
              className="text-xs font-semibold uppercase tracking-[0.3em] text-primary/70"
              data-testid="cta-helper"
            >
              Click to launch the 3D builder
            </span>
          </div>
        </div>
      </section>

      <SiteFooter />
    </div>
  );
}